import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-underConstruction',
  templateUrl: './underConstruction.component.html',
  styleUrls: ['./underConstruction.component.scss'],
})
export class underConstruction implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
